export const getYoutubeVideoId = (url) => {
  const regExp = /(?:\/embed\/|\/v\/|\/watch\?v=|youtu\.be\/|\/shorts\/)([a-zA-Z0-9_-]+)/;
  const match = url.match(regExp);

  return match && match[1].length === 11 ? match[1] : false;
};

export const getVimeoVideoId = (url) => {
  const regExp = /https?:\/\/(?:www\.)?(?:player\.)?vimeo(?:\.com|pro)?\/(?:[^\d]+)?(\d+)(?:.*)?/i;
  const match = url.match(regExp);

  if (match && match[1]) {
    return match[1];
  }
  return null;
};

export const uuidv4 = () => `${'xxxx'.replace(/x/g, () => Math.floor((Math.random() * 10e9)).toString(20))}`;
